import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionVisualDetail extends BaseModelAPI {
	static entity = 'productionqualityinspectionvisualdetail';
	static entityName = 'productionqualityinspectionvisualdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.productionQualityInspectionVisualId = '';
			this.productionQualityInspectionVisual = {};
			this.workOrderExecutionNgId = '';
			this.workOrderExecutionNg = {};
			this.problemCategoryId = '';
			this.problemCategory = {};
			this.ngQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}